var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-uploader"},[_c('image-uploader',{ref:"uploader",attrs:{"hidden":""}}),_c('a-button',{on:{"click":_vm.call}},[_vm._v("open")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }